import { render, staticRenderFns } from "./StepFive.vue?vue&type=template&id=3522c1d2&scoped=true&"
import script from "./StepFive.vue?vue&type=script&lang=js&"
export * from "./StepFive.vue?vue&type=script&lang=js&"
import style0 from "./StepFive.vue?vue&type=style&index=0&id=3522c1d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3522c1d2",
  null
  
)

export default component.exports